export const AI_QUERY_PARAM_KEY = 'aiQuery';
export const AI_MODAL_INPUT_SUBMIT_BUTTON_TEST_ID =
    'ai-multimodal-input-submit';

